import { Navigate, useLocation } from 'react-router-dom';
import PaginaEsito from './PaginaEsito';

// Il backend (verifica email) arriva qui con ?esito=ok|gia|errore e,
// per i coach, &tipo=coach.
const EmailVerificata = () => {
    const params = new URLSearchParams(useLocation().search);
    const esito = params.get('esito');
    const coach = params.get('tipo') === 'coach';
    const account = coach ? 'Il tuo account coach SportId®' : 'Il tuo account SportId®';

    // Gli utenti del Manager non vedono una pagina a parte: vanno al login con un messaggio e l'email gia' compilata
    // (`u`, aggiunta dal backend). Il login conosce gia' verified=S (ok), A (gia' verificata), E (errore).
    const verified = { ok: 'S', gia: 'A', errore: 'E' }[esito];
    if (!coach && verified) {
        const login = new URLSearchParams({ verified });
        const u = params.get('u');
        if (u) login.set('u', u);
        return <Navigate to={`/?${login.toString()}`} replace />;
    }

    if (esito === 'errore') {
        return (
            <PaginaEsito titolo="Non siamo riusciti a verificare la tua email" variante="danger">
                <p>Il link potrebbe essere scaduto o essere stato sostituito da uno più recente.</p>
                <p className="mb-0">Controlla di aver aperto l'ultima email di verifica che ti abbiamo mandato.</p>
            </PaginaEsito>
        );
    }

    if (esito === 'gia') {
        return (
            <PaginaEsito titolo="Email già verificata">
                <p>{account} era già stato verificato: non devi fare altro.</p>
                <p className="mb-0">Torna nell'app e accedi con le tue credenziali.</p>
            </PaginaEsito>
        );
    }

    return (
        <PaginaEsito titolo="Email verificata">
            <p>{account} è ora verificato.</p>
            <p className="mb-0">Torna nell'app e accedi con le tue credenziali.</p>
        </PaginaEsito>
    );
};

export default EmailVerificata;
